export default {"src":"/_next/static/media/GlusterFS.a976e4b4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};